// Skill 이미지
import html_icon from "../img/skill/html_icon.svg";
import css_icon from "../img/skill/css_icon.svg";
import javascript_icon from "../img/skill/javascript_icon.svg";
import typescript_icon from "../img/skill/typescript_icon.svg";
import react_icon from "../img/skill/react_icon.svg";
import sass_scss_icon from "../img/skill/sass_scss_icon.svg";
import bootstrap_icon from "../img/skill/bootstrap_icon.svg";
import mui_icon from "../img/skill/mui_icon.svg";
import tailwind_icon from "../img/skill/tailwind_icon.svg";
import git_icon from "../img/skill/git_icon.svg";
import node_icon from "../img/skill/node_js_icon.svg";
import mongodb_icon from "../img/skill/mongodb_icon.svg";

// Skill Components Data
export let skill_List: { src: string; alt: string; name: string }[] = [
  {
    src: html_icon,
    alt: "HTML icon",
    name: "HTML",
  },

  {
    src: css_icon,
    alt: "CSS icon",
    name: "CSS",
  },
  {
    src: javascript_icon,
    alt: "JavaScript icon",
    name: "JavaScript",
  },
  
  {
    src: typescript_icon,
    alt: "TypeScript icon",
    name: "TypeScript",
  },

  {
    src: react_icon,
    alt: "React icon",
    name: "React",
  },

  {
    src: sass_scss_icon,
    alt: "Sass(SCSS) icon",
    name: "Sass(SCSS)",
  },

  {
    src: bootstrap_icon,
    alt: "Bootstrap icon",
    name: "Bootstrap",
  },

  {
    src: mui_icon,
    alt: "MaterialUI icon",
    name: "MaterialUI",
  },

  {
    src: tailwind_icon,
    alt: "Tailwind icon",
    name: "Tailwind",
  },

  {
    src: node_icon,
    alt: "Node icon",
    name: "Node",
  },

  {
    src: mongodb_icon,
    alt: "MongoDB icon",
    name: "MongoDB",
  },

  {
    src: git_icon,
    alt: "Git icon",
    name: "Git",
  },

];